import type { ComponentType } from "react";

import { AvailablePropertiesIcon } from "../../icons/my-enquiry/available-properties-icon";
import { BookInspectionIcon } from "../../icons/my-enquiry/book-inspection-icon";
import { GeneralQueries } from "../../icons/my-enquiry/general-queries-icon";
import { GetValuationIcon } from "../../icons/my-enquiry/get-valueation-icon";
import { ListPropertyIcon } from "../../icons/my-enquiry/list-property-icon";
import { RequestDocIcon } from "../../icons/my-enquiry/request-doc-icon";
import type { AddEnquiryPickerType } from "./enquiry-types";
import { BookInspectionForm } from "./forms/book-inspection-form";
import { DocumentRequestForm } from "./forms/document_request-form";
import {
  AvailablePropertiesEnquiryForm,
  ContactUnreservedEnquiryForm,
} from "./forms/general_enquiry-form";

export type EnquiryModalConfig = {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  FormComponent?: ComponentType;
  formId?: string;
  redirectTo?: string;
};

export const enquiryModalMap: Record<AddEnquiryPickerType, EnquiryModalConfig> = {
  BOOK_INSPECTION: {
    icon: <BookInspectionIcon />,
    title: "Book An Inspection",
    subtitle: "Book public or private inspection",
    FormComponent: BookInspectionForm,
    formId: "book-inspection-form",
  },
  LIST_PROPERTY: {
    icon: <ListPropertyIcon />,
    title: "List Property",
    subtitle: "List your property for sale",
    formId: "list-property-form",
    redirectTo: "/create-listing",
  },
  PROPERTY_VALUATION: {
    icon: <GetValuationIcon />,
    title: "Get Valuation",
    subtitle: "Get a property valuation",
    formId: "get-valuation-form",
    redirectTo: "/valuation",
  },
  REQUEST_DOCUMENTS: {
    icon: <RequestDocIcon />,
    title: "Documents & Pest Inspection Request",
    subtitle: "Ask for required documents & building & pest inspection interest",
    FormComponent: DocumentRequestForm,
    formId: "document-request-form",
  },
  CONTACT_UNRESERVED: {
    icon: <GeneralQueries />,
    title: "Contact Unreserved",
    subtitle: "Need assistance?",
    FormComponent: ContactUnreservedEnquiryForm,
    formId: "general-enquiry-form",
  },
  AVAILABLE_PROPERTIES: {
    icon: <AvailablePropertiesIcon />,
    title: "Available Properties",
    subtitle: "View available properties",
    FormComponent: AvailablePropertiesEnquiryForm,
    formId: "general-enquiry-form",
  },
};
